// src/locales/ta/common.js
export const common = {
  id: "அடையாள எண்",
  save: "சேமிக்கவும்",
  cancel: "ரத்து செய்யவும்",
  info: "தகவல்",
  delete: "நீக்கவும்",
  edit: "திருத்தவும்",
  create: "உருவாக்கவும்",
  update: "புதுப்பிக்கவும்",
  updating: "புதுப்பிக்கிறது...",
  creating: "உருவாக்குகிறது...",
  search: "தேடவும்",
  loading: "ஏற்றுகிறது...",
  processing: "செயலாக்குகிறது...",
  yes: "ஆம்",
  no: "இல்லை",
  ok: "சரி",
  back: "பின்செல்",
  next: "அடுத்தது",
  previous: "முந்தையது",
  pageOf: "பக்கம் {{page}} / {{total}}",
  submit: "சமர்ப்பிக்கவும்",
  reset: "மீட்டமை",
  clear: "அழி",
  close: "மூடவும்",
  open: "திறக்கவும்",
  view: "காண்க",
  download: "பதிவிறக்க",
  print: "அச்சிடு",
  printReceipt: "ரசீதை அச்சிடு",
  export: "ஏற்றுமதி",
  upload: "பதிவேற்று",
  required: "தேவை",
  optional: "விருப்பத்தேர்வு",
  select: "தேர்ந்தெடுக்கவும்",
  selectAll: "அனைத்தையும் தேர்ந்தெடுக்கவும்",
  deselectAll: "அனைத்தையும் நீக்கவும்",
  actions: "செயல்கள்",
  status: "நிலை",
  active: "செயலில்",
  inactive: "செயலற்றது",
  enabled: "இயக்கப்பட்டது",
  disabled: "முடக்கப்பட்டது",
  or: "அல்லது",
  moreActions: "மேலும் செயல்கள்",
  retry: "மீண்டும் முயற்சி",
  refresh: "புதுப்பிக்க",
  clearSearch: "தேடலை நீக்கு",
  clearFilters: "Filters நீக்கு",
  filter: "வடிகட்டு",
  success: "வெற்றி",
  goBack: "திரும்பிச் செல்",
  created: "உருவாக்கப்பட்டது",
  createdBy: "உருவாக்கியவர்",

  // Pagination
  sortBy: "வரிசைப்படுத்து",
  showingResults: "{{start}} முதல் {{end}} வரை (மொத்தம்: {{total}})",
  page: "பக்கம்",
  of: "இல்",
  perPage: "பக்கத்திற்கு",
  firstPage: "முதல் பக்கம்",
  lastPage: "கடைசி பக்கம்",
  nextPage: "அடுத்த பக்கம்",
  previousPage: "முந்தைய பக்கம்",

  selectedCount: "{{count}} தேர்ந்தெடுக்கப்பட்டது",
  selected: "தேர்ந்தெடுக்கப்பட்டது",
  secondsAgo: "{{count}} விநாடிகளுக்கு முன்பு",
  minutesAgo: "{{count}} நிமிடங்களுக்கு முன்பு", 
  hoursAgo: "{{count}} மணி நேரங்களுக்கு முன்பு",
  daysAgo: "{{count}} நாட்களுக்கு முன்பு",
  monthsAgo: "{{count}} மாதங்களுக்கு முன்பு",
  yearsAgo: "{{count}} ஆண்டுகளுக்கு முன்பு",
  shop: "கடை",
  inStock: "கையிருப்பில் உள்ளது",
  outOfStock: "கையிருப்பில் இல்லை",
  na: "கிடைக்கவில்லை",
  clearAll: "அனைத்தையும் நீக்கு",
  show: "காட்டு",
  hide: "மறை",

  // Actions
  confirm: "உறுதிப்படுத்து",
  confirmUpdate: "புதுப்பிப்பை உறுதிப்படுத்து",

  // States
  readOnly: "படிக்க மட்டும்",

  // Messages
  error: "பிழை",
  validationError: "சரிபார்ப்பு பிழை",
  notAvailable: "கிடைக்கவில்லை",

  // Table / report labels
  count: "எண்ணிக்கை",
  total: "மொத்தம்",

  // Clipboard
  copy: "நகலெடு",
  copiedToClipboard: "Clipboard-க்கு நகலெடுக்கப்பட்டது!",
  copyFailed: "நகலெடுக்க முடியவில்லை",

  // Bulk import (shared across bulk order / bulk product import flows)
  bulkDragDropFile: "உங்கள் Excel கோப்பை இங்கே இழுத்து விடவும்",
  bulkOrClickToSelect: "அல்லது கோப்பைத் தேர்ந்தெடுக்க கிளிக் செய்யவும்",
  bulkSupportedFormats: "ஆதரிக்கப்படும் வடிவங்கள்: .xlsx, .xls, .csv",
  bulkFileUploaded: "கோப்பு வெற்றிகரமாக பதிவேற்றப்பட்டது",
  bulkInvalidFileFormat: "தவறான கோப்பு வடிவம். தயவுசெய்து .xlsx, .xls அல்லது .csv கோப்பைப் பதிவேற்றவும்",
  bulkFileParsingError: "கோப்பை பகுப்பாய்வு செய்வதில் பிழை. தயவுசெய்து கோப்பு வடிவத்தை சரிபார்க்கவும்",
  loadingData: "தரவு ஏற்றப்படுகிறது...",
  viewDetails: "விவரங்களைப் பார்க்கவும்",
  createdDate: "உருவாக்கப்பட்ட தேதி",
  none: "எதுவும் இல்லை",
  excel: "Excel",
  saving: "சேமிக்கிறது",
  uploading: "பதிவேற்றுகிறது...",
  ref: "குறிப்பு",
  saveChanges: "மாற்றங்களைச் சேமி",
  duplicate: "நகலெடு",
  continue: "தொடரவும்",
  clearSelection: "தேர்வை அழி",
  applyToAll: "அனைத்திற்கும் பயன்படுத்து",
  all: "அனைத்தும்",
  updatedAt: "புதுப்பிக்கப்பட்டது",
  accessDenied: "அணுகல் மறுக்கப்பட்டது",
  country: "நாடு",
  unsavedChangesTitle: "சேமிக்கப்படாத மாற்றங்கள்",
  leave: "வெளியேறு",
  stay: "இருக்கவும்",
};
